import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {StudentScheduleApiResponse} from "../../types/apiResponse.interface";
import {PreloaderService} from "../../services/preloader/preloader.service";
import {StudentService} from "../../services/mygreencountry/student.service";
import {NextLessonData, Schedule, ScheduleGroup} from "../../types/interfaces";
import {MyGreenCountry} from "../../services/mygreencountry/my-greencountry";
import {TelegramComponent} from "../../shared/components/modals/chose-group/telegram/telegram.component";
import {ModalController} from "@ionic/angular";
import {PracticingComponent} from "../../shared/components/modals/chose-group/practicing/practicing.component";
import {TransferLessonsComponent} from "../../shared/components/modals/transfer-lessons/transfer-lessons.component";
import {TranslocoService} from "@jsverse/transloco";
import {Title} from "@angular/platform-browser";
import {Observable} from "rxjs";

@Component({
    selector: 'app-schedule',
    templateUrl: './schedule.page.html',
    styleUrls: ['./schedule.page.scss'],
    // changeDetection: ChangeDetectionStrategy.OnPush
})
export class SchedulePage implements OnInit {
    title$: Observable<string>;

    @ViewChild('ionDatetime') ionDatetime: ElementRef;
    activeFuturesGroupsTabs = false;
    activeCurrentGroupsTabs = true;

    currentLessons: { title: string, color: string, data: NextLessonData }[];
    futureLessons: { title: string, color: string, data: NextLessonData }[];
    currentSchedule: Schedule[];
    futureSchedule: Schedule[];
    currentGroups: ScheduleGroup[];
    futureGroups: ScheduleGroup[];
    currentHolidays: string[];
    futureHolidays: string[];
    hasFutureGroup = true;
    activeTime: string = 'isCurrent'

    activeGroupTime$ = this.GCService.getActiveGroupTime();

    constructor(
        private preloaderService: PreloaderService,
        private studentService: StudentService,
        public myGcService: MyGreenCountry,
        private modalCtrl: ModalController,
        private GCService: MyGreenCountry,
        private translocoService: TranslocoService,
        private titleService: Title
    ) {

        this.activeGroupTime$.subscribe({
            next: (activeTime) => {

                this.activeTime = activeTime;

                this.setActiveTab();

            }
        })

        this.title$ = this.translocoService.selectTranslate('route.schedule');

        this.title$.subscribe(title => {
            this.titleService.setTitle(title);
        });
    }

    ngOnInit() {

        this.loadSchedule();
    }

    ngAfterViewInit() {

    }

    refresh(event: any) {
        this.loadSchedule(event);
    }

    setActiveTab() {
        if (this.activeTime === 'isFuture') {
            this.activeCurrentGroupsTabs = false;
            this.activeFuturesGroupsTabs = true;
        }
    };


    async loadSchedule(event: any = null) {
        await this.preloaderService.showLoading("Зачекайте, будь ласка ");

        this.studentService.getSchedule()
            .subscribe({

                next: (response: StudentScheduleApiResponse) => {
                    this.currentGroups = [];
                    this.futureGroups = [];

                    this.processGroups(response.groups, 'isCurrent');
                    this.processGroups(response.groups, 'isFuture');
                },

                error: (error) => {
                    console.log('error', error)

                },

                complete: () => {
                    this.preloaderService.hideLoading();

                    if (event) {
                        event.target.complete();
                    }
                }

            })
    }

    processGroups(groups: ScheduleGroup[], type: string) {

        const filteredGroups = groups.filter(group => group.time === type);

        if (filteredGroups.length > 0) {
            let lessons = filteredGroups.map(group => ({
                title: group.title,
                color: group.color,
                data: group.nextLesson
            }));

            this.sortDataAccordingToDate(lessons);

            if (type === 'isCurrent') {
                this.currentGroups = filteredGroups;
                this.currentLessons = lessons;
                this.currentSchedule = filteredGroups.map(group => group.schedule);
                this.currentHolidays = filteredGroups.map(group => group.holidaysFullName);
            } else if (type === 'isFuture') {
                this.futureGroups = filteredGroups;
                this.futureLessons = lessons;
                this.futureSchedule = filteredGroups.map(group => group.schedule);
                this.futureHolidays = filteredGroups.map(group => group.holidaysFullName);
            }
        }
    }


    sortDataAccordingToDate(lessons: { title: string, color: string, data: NextLessonData }[]) {
        lessons.sort((a, b) => {
            let dateA = new Date(a.data.dateMonth.split('.').reverse().join('-')).getTime();
            let dateB = new Date(b.data.dateMonth.split('.').reverse().join('-')).getTime();

            return dateA - dateB;
        });
    }

    async openModal(type: string, groups: ScheduleGroup[]) {
        if (groups) {
            // if (groups?.length === 1) {
            //     if (type === 'practicing') {
            //         this.openUrl(groups[0].practicingUrl)
            //     }
            // } else {
            await this.openChoseGroupModal(type, groups)
            // }
        }

    }

    openUrl(url: string) {
        if (url) {
            this.myGcService.openUrl(url);
        }
    }

    async openChoseGroupModal(type: string, groups: ScheduleGroup[]) {
        let paidGroups = groups.filter(group => !group.isReserve)

        let modal = await this.modalCtrl.create({
            component: type === 'practicing' ? PracticingComponent : TelegramComponent,
            cssClass: 'chose-modal auto-height',
            componentProps: {
                groups: paidGroups,
                type: type,
            }
        });

        modal.onWillDismiss().then(({data, role}) => {
            if (role === 'openTransferModal') {

                this.openTransferModal();
            }
        });

        await modal.present();
    }

    async openTransferModal() {
        const modal = await this.modalCtrl.create({
            component: TransferLessonsComponent,
            cssClass: 'chose-modal auto-height',
            componentProps: {
                groups: this.currentGroups,
            }
        });

        await modal.present();
    }

    protected readonly length = length;
}
